import React from 'react'
import PropTypes from 'prop-types'
import ActionsMenu from '../../ui/ActionsMenu'
import PenIcon from '../../ui/icons/PenIcon'
import ShareNodesIcon from '../../ui/icons/ShareNodesIcon'
import DownloadIcon from '../../ui/icons/DownloadIcon'

const RowActionsMenu = ({ anchorEl = null, isOpen, onClose, onEdit, onShare, onExportPdf }) => {
  const items = [
    { label: 'Gérer l’alerte', icon: PenIcon, onClick: onEdit },
    { label: 'Partager', icon: ShareNodesIcon, onClick: onShare },
    { label: 'Exporter en PDF', icon: DownloadIcon, onClick: onExportPdf }
  ]
  return (
    <ActionsMenu
      anchorEl={anchorEl}
      ariaLabel="Actions sur l’alerte"
      isOpen={isOpen}
      items={items}
      onClose={onClose}
    />
  )
}

RowActionsMenu.propTypes = {
  anchorEl: PropTypes.instanceOf(Element),
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onExportPdf: PropTypes.func.isRequired,
  onShare: PropTypes.func.isRequired
}

RowActionsMenu.defaultProps = {
  anchorEl: null
}

export default RowActionsMenu
